import { GFPADashboardNavigation } from '@/components/GFPA/GFPADashboardNavigation'
import GFPAHeader from '@/components/GFPA/GFPAHeader'
import { IGfpaSummaryDTO } from '@/interfaces/gfpaReport.interface'
import { ReportDashboardLayout } from '@/Layouts/ReportDashboardLayout'
import VerticallySplitLayout from '@/Layouts/VerticallySplitLayout'
import {
  clearGFPASummary,
  fetchGFPASummaryAsync,
} from '@/states/axiomReport.slice'
import { AgGridReact } from '@ag-grid-community/react'
import { GFPASummaryChart } from '@components/GFPA/SummaryReport/GFPASummaryChart'
import { GFPASummaryTable } from '@components/GFPA/SummaryReport/GFPASummaryTable'
import { useAppDispatch } from '@hooks/use-app-dispatch'
import { useAppSelector } from '@hooks/use-app-selector'
import { Box, CircularProgress, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const GFPASummaryPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [gridReference, setGridReference] = useState<AgGridReact>()
  const [rowData, setRowData] = useState<IGfpaSummaryDTO[]>([])
  const selectedReport = useAppSelector((s) => s.axiomReport.selectedReport)
  const gfpaSummary = useAppSelector((s) => s.axiomReport.gfpaReport.summary)
  const showLoader = useAppSelector((s) => s.axiomReport.showLoader)

  useEffect(() => {
    if (
      Object.keys(selectedReport).length &&
      selectedReport.reportType === 'GFPA' || selectedReport.reportType === 'GFPAH'
    ) {
      dispatch(fetchGFPASummaryAsync(selectedReport.reportId))
    } else {
      navigate('/')
    }
  }, [selectedReport])

  useEffect(() => {
    gfpaSummary && gfpaSummary.length && setRowData(gfpaSummary)
  }, [gfpaSummary])

  useEffect(() => {
    return () => {
      dispatch(clearGFPASummary())
    }
  }, [])

  return (
    <ReportDashboardLayout
      selectedReport={selectedReport}
      navigation={<GFPADashboardNavigation />}
    >
      {showLoader ? (
        <Box
          display='grid'
          height='100%'
          alignItems='center'
          justifyContent='center'
          role='loading'
        >
          <CircularProgress color='primary' />
        </Box>
      ) : (
        <VerticallySplitLayout
          contentTop={<GFPASummaryChart chartData={rowData} />}
          contentBottom={
            <GFPASummaryTable
              rowData={rowData}
              setGridReference={setGridReference}
              reportType={selectedReport.reportType}
            />
          }
          headerTop={
            <Typography variant='h4' my={-2}>
              Portfolio Details
            </Typography>
          }
          headerBottom={
            <GFPAHeader
              reportData={selectedReport}
              gridReference={gridReference as AgGridReact}
            />
          }
        />
      )}
    </ReportDashboardLayout>
  )
}
